<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" rounded color="white">
        <v-icon small class="pr-4">mdi-plus-circle-outline</v-icon>
        Lägg till
      </v-btn>
    </template>
    <TurnaroundCreateModal v-if="dialog" @close="dialog = false" />
  </v-dialog>
</template>

<script>
import TurnaroundCreateModal from './TurnaroundCreateModal'

export default {
  name: 'TurnaroundCreateButton',

  components: {
    TurnaroundCreateModal
  },

  data: () => ({
    dialog: false
  })
}
</script>
